import {
  Button,
  Checkbox,
  Col,
  Divider,
  Drawer,
  Form,
  Menu,
  message,
  Popover,
  Row,
  Typography,
} from "antd";
import appBarCode from "../../assets/appBarCode.png";
import DocUpdateIcon from "../../assets/DocUpdateIcon.svg";
import { ReactComponent as ChevronLeft } from "../../assets/chevron-left.svg";
import { ReactComponent as SignUpDocIcon } from "../../assets/signupdocIcon.svg";
import { ReactComponent as MenuFoldIcon } from "../../assets/MenuUnfoldIcon.svg";
import SignUpDocMiniIcon from "../../assets/signupMiniIcon.webp";
import { useForm } from "../../utils/hooks/useForm";
import PhoneInput, { CountryData } from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import FloatInput from "../../components/FloatInput/floatInput";
import "./signup.modules.css";
import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/hooks/useAuth";
import {
  allowNumOnly,
  confirmPasswordValidation,
  emailPattenValidation,
  passwordPatternValidation,
  policyCheckboxValidation,
  usPhoneNumberRule,
  validateExactLength,
  validateMaxValue,
  validateNPIPattern,
} from "../../utils/methods/form-validations";
import { DownOutlined } from "@ant-design/icons";
import { NamePath, StoreValue } from "antd/es/form/interface";
import { useSideBarMenu } from "../../utils/content/sidebar-menus";
import HipaaSealImage from "../../components/HipaaSeal/HipaaSeal";

const SignupV1 = () => {
  const navigate = useNavigate();
  const { form } = useForm();
  const { NAVBAR_INFO_MOBILE, POPUP_CONTENT, open, setOpen } = useSideBarMenu();
  const { findUserByNPI, isApiLoading, smsSignUp } = useAuth(form);
  const [tabKey, setTabKey] = React.useState(1);
  const [countryData, setCountryData] = React.useState<CountryData | undefined>(
    undefined
  );
  const [showPlaceholder, setShowPlaceholder] = React.useState<boolean>(true);
  const [isPhoneHasError, setIsPhoneHasError] = React.useState<boolean>(false);

  const formatPhoneNumber = (value: string): string => {
    const digits = value.replace(/\D/g, "").slice(0, 10); // Max 10 digits

    if (!digits) return ""; // <-- Fix: If empty, return empty string

    const area = digits.slice(0, 3);
    const prefix = digits.slice(3, 6);
    const line = digits.slice(6, 10);

    if (digits.length <= 3) return `(${area}`;
    if (digits.length <= 6) return `(${area}) ${prefix}`;
    return `(${area}) ${prefix}-${line}`;
  };

  const handleFinishNetwork = (values: StoreValue) => {
    if (tabKey === 1) {
      findUserByNPI({ ...values }, setTabKey, form);
    } else if (tabKey === 2) {
      smsSignUp({ ...values }, setShowPlaceholder, form);
    }
  };

  const onNetworkFinishFailed = (errorInfo: StoreValue) => {
    const checkPhoneNumber =
      form.getFieldError("network_phoneNumber")?.length > 0;
    setIsPhoneHasError(checkPhoneNumber);
    if (
      errorInfo.values.privacyPolicyAgreement &&
      errorInfo.errorFields.length &&
      tabKey === 2
    ) {
      message.error(
        "Please complete all required fields in the previous steps before proceeding."
      );
    }
  };

  return (
    <div className="bg-custom-radial flex flex-col w-full lg:h-full justify-between">
      <div className="my-2 flex flex-col justify-center items-center px-6 py-4 w-full max-w-[1440px] mx-auto lg:gap-y-8">
        <div className="flex justify-center items-center w-full max-w-screen-2xl lg:gap-x-40">
          <div className="flex justify-between gap-x-8 items-center w-full lg:w-auto">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal lg:mr-auto"
              />
            </Link>
            <MenuFoldIcon
              onClick={() => setOpen((prevState) => !prevState)}
              className="lg:hidden text-[#565656]"
            />
            <Popover
              placement="bottom"
              title={""}
              content={POPUP_CONTENT}
              className="nav_popover"
            >
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="hidden link-block lg:flex justify-center items-center"
                onClick={(e) => e.preventDefault()}
              >
                What We Offer <DownOutlined className="chevron-down" />
              </Link>
            </Popover>
            <Link
              to={"https://www.docupdate.io/manage-preferences"}
              className="hidden link-block lg:flex justify-center items-center"
            >
              Manage Preferences
            </Link>
          </div>
          <div className="hidden lg:flex justify-center gap-x-4 items-center">
            <Link
              to={"/signup-new"}
              className="link-button-white flex justify-center items-center"
            >
              Sign Up
            </Link>
            <Link
              to={"https://docupdate.onelink.me/j4xR/desktop"}
              className="link-button flex justify-center items-center"
            >
              Get the App
            </Link>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row justify-center items-center w-full lg:gap-x-20 lg:pr-0 lg:pl-8 lg:items-start">
          <div className="hidden lg:flex lg:flex-col lg:gap-y-7 lg:justify-center lg:items-center lg:m-0">
            <div className="flex flex-col gap-y-2 justify-center">
              <Typography.Text className="font-playfair font-bold text-[48px]">
                Create Account
              </Typography.Text>
              <div className="w-full">
                <SignUpDocIcon className="object-cover w-[89%] h-full" />
              </div>
            </div>
          </div>
          <div className="lg:hidden flex flex-col gap-y-4 justify-center items-center mt-10">
            <Typography.Text className="font-playfair font-semibold text-[38px] leading-[120%] tracking-[-2%] text-center">
              Create Account
            </Typography.Text>
          </div>
          {/* User Signup Tab */}
          <div className="my-6 pt-2 flex flex-col w-full max-w-[470px] justify-center items-start rounded-xl mobile-m:rounded-3xl mobile-m:pl-2 lg:my-0 lg:mt-3 gap-y-6">
            <Form
              form={form}
              name="network-signup"
              onFinish={handleFinishNetwork}
              onFinishFailed={onNetworkFinishFailed}
              className="pt-2 flex flex-col bg-white w-full max-w-[470px] justify-center items-center rounded-xl mobile-m:rounded-3xl mobile-m:px-2 lg:my-0"
            >
              <div className="flex flex-col justify-center items-center w-full max-w-[380px] ">
                <div className="w-full flex justify-between items-center max-w-[240px] mobile-m:max-w-[380px] lg:mt-8">
                  {tabKey === 2 && (
                    <Button
                      className="bg-transparent border-solid border-[#d5d7da] rounded-[8px] p-4 hover:bg-[#e8f3ff] hover:text-[#7e5aeb]"
                      icon={<ChevronLeft />}
                      onClick={() => setTabKey(1)}
                    />
                  )}
                  <Typography.Text
                    className={`font-playfair text-center text-3xl text-[#0F0F1C] w-full font-bold ${
                      tabKey === 1 ? "ml-8" : "mr-8"
                    }`}
                  >
                    Sign Up
                  </Typography.Text>
                  {tabKey === 1 && (
                    <Button
                      className="bg-transparent border-solid border-[#D5D7DA] text-[#A8BDC1] rounded-[8px] p-4 hover:bg-[#fefefe] hover:text-[#7e5aeb]"
                      icon={<ChevronLeft className="rotate-180" />}
                      onClick={() => setTabKey(2)}
                    />
                  )}
                </div>
                <Typography.Text className="m-4 font-urbanist text-center leading-4 text-[12px] w-full font-medium text-[#5d6769] mobile-m:text-sm">
                  Welcome to DocUpdate.
                </Typography.Text>

                <Typography.Text className="mx-4 mt-0 mb-1 max-w-[85%] font-urbanist text-center font-medium leading-[1] text-[12px] w-full text-[#5d6769] mobile-m:text-sm lg:text-[15px] mobile-m:max-w-[90%] lg:max-w-[100%]">
                  Please confirm your information. Stay ahead with tailored
                  updates from DocUpdate, bringing you the latest advancements
                  in medications, indications, and services in your field.
                </Typography.Text>

                {/* Tab container with absolute positioning */}
                <div
                  className={`w-full `}
                >
                  {tabKey === 1 && <div
                    className={`w-full animate-fade-in"
                    }`}
                  >
                    <Row
                      gutter={[12, tabKey === 1 ? 16 : 8]}
                      className="px-4 xs:px-0 lg:!gap-y-3"
                      wrap
                      align={"middle"}
                      justify={"center"}
                    >
                      {/* First Tab Fields */}
                      <Col span={24}>
                        <Form.Item
                          name="network_npiNumber"
                          rules={[
                            {
                              required: true,
                              message: "*NPI is Required",
                            },
                            validateNPIPattern(),
                            validateExactLength("NPI", 10),
                            validateMaxValue("NPI", 2147483647),
                          ]}
                          validateFirst
                        >
                          <FloatInput
                            name={"network_npiNumber"}
                            type="text"
                            placeholder={"1234567890"}
                            maxLength={10}
                            label={"NPI"}
                            required={true}
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => allowNumOnly(e, form, "network_npiNumber")}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="relative md:mb-1">
                        <Form.Item
                          name="network_phoneNumber"
                          rules={[usPhoneNumberRule]}
                          validateFirst
                        >
                          <FloatInput
                            label="Mobile Phone Number"
                            type="text"
                            required={true}
                            placeholder="(555) 555-5555"
                            value={form.getFieldValue("network_phoneNumber")}
                            onChange={(e: any) =>
                              form.setFieldsValue({
                                network_phoneNumber: formatPhoneNumber(
                                  e.target.value
                                ),
                              })
                            }
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>}

                  {tabKey === 2 && <div
                    className={"w-full animate-fade-in"}
                  >
                    <Row className="px-4" gutter={8}>
                      {/* Second Tab Content */}
                      <Col span={12} className="p-0">
                        <Form.Item
                          name={"network_firstName"}
                          rules={[
                            {
                              required: !!(tabKey === 2),
                              message: "*First Name is Required",
                            },
                          ]}
                        >
                          <FloatInput
                            name={"network_firstName"}
                            placeholder={"Sam"}
                            label="First Name"
                            required={true}
                            type="text"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={12} className="p-0 mb-3">
                        <Form.Item
                          name={"network_lastName"}
                          rules={[
                            {
                              required: !!(tabKey === 2),
                              message: "*Last Name is Required",
                            },
                          ]}
                        >
                          <FloatInput
                            name={"network_lastName"}
                            type="text"
                            label="Last Name"
                            placeholder={"Smith"}
                            required
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="mb-4">
                        <Form.Item
                          name="network_email"
                          rules={[
                            {
                              required: !!(tabKey === 2),
                              message: "*Email Address is Required",
                            },
                            ...(tabKey === 2 ? [emailPattenValidation()] : []),
                          ]}
                          validateFirst
                        >
                          <FloatInput
                            name={"network_email"}
                            type="text"
                            placeholder={"name@email.com"}
                            label="Email Address"
                            required={true}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="mb-6">
                        <Form.Item
                          name="network_password"
                          rules={[
                            {
                              required: !!(tabKey === 2),
                              message: "*Password is Required",
                            },
                            ...(tabKey === 2
                              ? [passwordPatternValidation()]
                              : []),
                          ]}
                          validateFirst
                          hasFeedback
                        >
                          <FloatInput
                            name={"network_password"}
                            type="password"
                            placeholder={"********"}
                            required={true}
                            label="Password"
                          />
                        </Form.Item>
                      </Col>
                      <Col span={24} className="mb-2">
                        <Form.Item
                          name="confirmPassword"
                          rules={[
                            {
                              required: !!(tabKey === 2),
                              message: "*Confirm Password is Required",
                            },
                            ...(tabKey === 2
                              ? [
                                  ({
                                    getFieldValue,
                                  }: {
                                    getFieldValue: (
                                      name: NamePath
                                    ) => StoreValue;
                                  }) =>
                                    confirmPasswordValidation(getFieldValue),
                                ]
                              : []),
                          ]}
                          validateFirst
                          hasFeedback
                        >
                          <FloatInput
                            name={"confirmPassword"}
                            type="password"
                            placeholder={"********"}
                            required={true}
                            label="Confirm Password"
                          />
                        </Form.Item>
                      </Col>
                      <div className="mt-4 flex justify-center items-center mx-auto">
                        <Form.Item
                          name={"privacyPolicyAgreement"}
                          valuePropName="checked"
                          rules={[policyCheckboxValidation(tabKey)]}
                          className="consent-form"
                        >
                          <Checkbox className="custom-checkbox w-full max-w-[440px] font-urbanist leading-none text-xs text-[#050505]">
                            By submitting this form and signing up for texts,
                            you consent to receive messages from DocUpdate at
                            the number provided, including messages sent by an
                            autodialer or AI generated messages or voice calls.
                            Consent is not a condition of purchase. Msg & data
                            rates may apply. Msg frequency varies. Unsubscribe
                            at any time by replying STOP or clicking the
                            unsubscribe link (where available). I read and agree
                            with the DocUpdate{" "}
                            <Link
                              to={"https://www.docupdate.io/ccpa-notice/"}
                              className="text-[#7056D6] underline font-lato font-bold"
                            >
                              {" "}
                              CCPA Policy
                            </Link>
                            {", "}
                            <Link
                              to={"https://www.docupdate.io/privacy-policy"}
                              className="text-[#7056D6] underline font-lato font-bold"
                            >
                              Privacy Policy
                            </Link>{" "}
                            and{" "}
                            <Link
                              to={"https://www.docupdate.io/terms-of-service/"}
                              className="text-[#7056D6] underline font-lato font-bold"
                            >
                              Terms of Service
                            </Link>
                            .
                          </Checkbox>
                        </Form.Item>
                      </div>
                    </Row>
                  </div>}
                </div>
                <Col
                  span={24}
                  className="mt-3 mb-6 px-4 flex justify-center items-center w-full xs:px-0"
                >
                  <Button
                    htmlType="submit"
                    className="bg-[#7E5AE2] text-white py-[18px] border-none w-full font-semibold rounded-full text-sm disabled:opacity-45"
                    loading={isApiLoading}
                    iconPosition="end"
                  >
                    {tabKey === 1 ? "NEXT" : "SIGN UP"}
                  </Button>
                </Col>
              </div>
            </Form>
            <div className="hidden lg:flex flex-col gap-y-4">
              <Typography.Text className="font-bold text-lg font-poppins text-left w-full">
                Scan the QR code to download the app!
              </Typography.Text>
              <img
                src={appBarCode}
                className="ml-1 p-3 bg-white rounded-lg w-full max-w-32 app-bar-code-shadow"
              />
            </div>
          </div>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="my-3 link-button flex justify-center items-center lg:hidden w-full max-w-[300px]"
          >
            Get the App
          </Link>
          <div className="mt-2 flex flex-col w-full h-full max-h-[318px] max-w-[320px] lg:hidden">
            <img
              src={SignUpDocMiniIcon}
              className="object-contain h-full w-[100%]"
            />
          </div>
        </div>
      </div>
      <div className="mt-6 bg-[#f2fdff] flex flex-col w-full justify-center items-center">
        <div className="min-h-400px px-6 py-4 flex w-full max-w-[1080px] justify-between items-start">
          <div className="flex flex-col justify-center items-start gap-y-4 md:gap-y-6">
            <Link to={"https://www.docupdate.io/"}>
              <img
                src={DocUpdateIcon}
                alt="docupdate"
                className="w-full max-w-48 object-contain mix-blend-normal"
              />
            </Link>
            <div className="flex flex-col items-start gap-y-4 md:flex-row md:gap-x-8">
              <Link
                to={"https://www.docupdate.io/manage-preferences"}
                className="link-block-light flex justify-center items-center"
              >
                Manage Preferences
              </Link>
              <Link
                to={"https://www.docupdate.io/#faq"}
                className="link-block-light flex justify-center items-center"
              >
                Help
              </Link>
              <Link
                to={"https://www.docupdate.io/privacy-policy/"}
                className="link-block-light flex justify-center items-center"
              >
                Privacy Policy
              </Link>
            </div>
          </div>
          <HipaaSealImage />
        </div>
        <Divider className="w-full max-w-screen-2xl" />
        <div className="flex flex-col md:flex-row justify-between items-center w-full p-4 max-w-[1080px] gap-y-3">
          <div className="flex justify-center items-center">
            <Typography.Text className="footer-text-color">
              Copyright © 2025 DocUpdate | All Rights Reserved.
            </Typography.Text>
          </div>
          <div className="flex justify-center gap-x-8 items-center">
            <Link
              to={"https://www.docupdate.io/terms-of-service/"}
              className="link-block-lighter flex justify-center items-center"
            >
              Terms of Service
            </Link>
            <Link
              to={"https://www.docupdate.io/do-not-call-policy/"}
              className="link-block-lighter flex justify-center items-center"
            >
              DNC Policy
            </Link>
            <Link
              to={
                "https://www.docupdate.io/hipaa-business-associate-agreement/"
              }
              className="link-block-lighter flex justify-center items-center"
            >
              HIPAA Terms
            </Link>
            <Link
              to={"https://www.docupdate.io/ccpa-notice/"}
              className="link-block-lighter flex justify-center items-center"
            >
              CCPA Notice
            </Link>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={true}
        onClose={() => setOpen(false)}
        open={open}
        destroyOnClose
        className={`navbar_drawer flex justify-center p-[0.85rem_1.5rem] w-full`}
      >
        <div className="flex flex-col gap-y-10 w-full h-full">
          <Typography.Text className="font-playfair text-3xl text-center">
            What We Offer
          </Typography.Text>
          <Menu
            mode="inline"
            className="w-full h-full border-none flex flex-col gap-y-4 max-h-[360px]"
            items={NAVBAR_INFO_MOBILE}
            defaultSelectedKeys={["1"]}
          />
          <Link
            to={"/signup-new"}
            className="link-button-white flex justify-center items-center"
          >
            Sign Up
          </Link>
          <Link
            to={"https://docupdate.onelink.me/j4xR/desktop"}
            className="link-button flex justify-center items-center"
          >
            Get the App
          </Link>
        </div>
      </Drawer>
    </div>
  );
};

export default SignupV1;
